// extracted by mini-css-extract-plugin
module.exports = {"Container":"SliderTextCards__Container_1ofSc","Card":"SliderTextCards__Card_3Jz-P"};